import axios from 'axios'
//import { serverURL } from "@/config"

const API_BASE = '/wp-json/s3m/v1/processdb'
//const SERVER_URL = `${process.env.VUE_APP_API_URL}`;

class APIService {

    getProcessContentByProcessId( processId ) {
        return axios.get(window.$config.API_URL+`${API_BASE}/processes/${processId}/process_content`)
    }

    async getProcesses() {
        const result = await axios.get(window.$config.API_URL+`${API_BASE}/processes`)
        return result.data
    }

    async getTaxonomieTerms(taxonomie) {
        const result = await axios.get(window.$config.API_URL+`${API_BASE}/taxonomies/${taxonomie}`)
        return result.data
    }

    async getStellen(){
        const endpoint = window.$config.POST_NAME == "jobs_p" ? "stellen_p" : "stellen";
        console.log(window.$config.API_URL + `${API_BASE}/${endpoint}`);
        const result = await axios.get(window.$config.API_URL + `${API_BASE}/${endpoint}`);
        return result.data;
    }

    async getOwnManufacturePosts() {
        const result = await this.callAPI()(window.$config.API_URL+`${API_BASE}/manufacturer_posts?current_user=true&post_type=herstellerinfo`);
        console.log(result)
        return result.data.length > 0 ? result.data : null
    }
    getManufacturerPostsByManufacturer(manufacturerId) {
        return axios.get(window.$config.API_URL+`${API_BASE}/manufacturer_posts?post_type=herstellerinfo&user_id=${ manufacturerId }`).then((response) => {
            return response.data
        })
    }

     createManufacturerInfo(info)  {
        return axios.post(window.$config.API_URL+`${API_BASE}/manufacturer_posts`, info).then(response => {
            return response.data
        });
    }

    updateManufacturerInfo(info)  {
        return axios.put(window.$config.API_URL+`${API_BASE}/manufacturer_posts/${ info.id }`, info).then(response => {
           return response.data
        });
    }

    async deleteManufacturerInfo(info) {
        await axios.delete(window.$config.API_URL+`${API_BASE}/manufacturer_posts/${ info.id }`, info);
    }

    getManufacturerInfo(id){
        return this.callAPI()(window.$config.API_URL+`${API_BASE}/manufacturer_posts/${id}`).then(result => result.data);
    }
    async getManufacturers() {
        return await axios.get(window.$config.API_URL+`${API_BASE}/manufacturers`).then((response) => {
            return response.data.manufacturers
        })
    }

    getProcessPosts(processId, postType) {
        return axios(window.$config.API_URL+`${API_BASE}/manufacturer_posts?process_id=${processId}&post_type=${postType}`);
    }


    async searchManufacturerInfo(query) {
        const result =  await this.callAPI()(window.$config.API_URL+`${API_BASE}/manufacturer_posts?${this.objectToParams(query)}`);
        return result.data.length > 0 ? result.data : []
    }
    async getProfile(id = undefined) {
        const result =  await this.callAPI()(window.$config.API_URL+`${API_BASE}/manufacturer_profile${ typeof(id) === 'undefined'? '' : '?id=' + id }`);
        return result.data
    }
    async updateProfile(profile) {
        return axios.put(window.$config.API_URL+`${API_BASE}/manufacturer_profile`, {
            ...profile
        })
    }

    objectToParams(obj) {
        let params = ""
        let first = true
        for(let prop in obj) {
            if(!first) params += "&"
            params +=  `${prop}=${obj[prop]}`
            first = false;
        }
        return params
    }

    async getImages() {
        const result =  await this.callAPI()(window.$config.API_URL+`/wp-json/s3m/v1/manufacturer_info/images`);
        return result.data.length > 0 ? result.data : null
    }
    callAPI() {
        const sources = {}
        return async (url) => {
            // TODO Tokens should be configurable depending on request URL
            let source = sources['getProcessContentByProcessId']
            if(source) {
                source.cancel()
            }
            source = axios.CancelToken.source()
            sources['getProcessContentByProcessId'] = source
            return await axios.get(url ,{ cancelToken: source.token  }).catch((err) => {
                console.log("Error:". err)
                if(axios.isCancel(err)) {
                    return Promise.reject("Request canceled")
                }
                if(err.statusCode === 404) {
                    return Promise.reject("Resource not found")
                }
            })
        }
    }
}
export default new APIService()
